import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useFootballPromotion } from '@/contexts/FootballPromotionContext';
export default function FootballWeekendBanner() {
  const { user } = useAuth();
  const { offer } = useFootballPromotion();
  if (!offer || !['free', 'paid', 'upcoming'].includes(offer.state)) return null;
  const free = offer.state === 'free';
  return <aside className="border-b border-[#FF6B1A]/40 bg-[#FF6B1A]/10 px-4 py-4 text-center" data-testid="football-month-banner">
    <div className="mx-auto max-w-6xl flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6">
      <div><p className="text-[#FF6B1A] font-heading font-black text-xl uppercase">
        {free ? 'AI PARLAY PICKS FREE FOR THE NEXT MONTH' : 'BASIC FOOTBALL AI PICKS · $3.99/MONTH'}
      </p><p className="text-white/70 text-sm">
        College and pro football only · Basic limits apply · {free ? 'Oct 3–Nov 2. Completed signup + verified email required.' : 'Optional enrollment. Cancel anytime.'}
      </p></div>
      <Link to={free && !user ? '/register?offer=football-month' : '/football-month'} className="rounded-md bg-[#FF6B1A] px-5 py-3 text-black font-bold whitespace-nowrap">
        {free && !user ? 'SIGN UP FREE →' : 'VIEW FOOTBALL OFFER →'}
      </Link>
    </div>
  </aside>;
}
